export const DEFAULT_TAG_COLOR = '#fef08a';

export type ColoredTag = {
  tagId: string;
  tagName: string;
  color?: string | null;
};

/** 無効・未設定の色は従来の黄色で表示する。 */
export function tagColor(color?: string | null): string {
  return color && /^#[0-9a-fA-F]{6}$/.test(color)
    ? color.toLowerCase()
    : DEFAULT_TAG_COLOR;
}

/** タグの背景色を適用し、文字色は常に黒で表示する。 */
export function tagStyle(color?: string | null): {
  backgroundColor: string;
  color: string;
} {
  return { backgroundColor: tagColor(color), color: '#000000' };
}
